import { render, staticRenderFns } from "./MultipleChoicePure.vue?vue&type=template&id=1ce47e5f&scoped=true&"
import script from "./MultipleChoicePure.vue?vue&type=script&lang=js&"
export * from "./MultipleChoicePure.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoicePure.vue?vue&type=style&index=0&id=1ce47e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce47e5f",
  null
  
)

export default component.exports